/* eslint-disable @typescript-eslint/no-explicit-any */
import { AllupBetlineFragment, BetPickEntryFragment } from '@graphqlTypes/sitecore';
import OddsStore from '@mobx/stores/kolBetpick/kolOddsLastDate';
import { DeepReadonly } from './type-utils';

/** 是否英文 */
export const isEn = typeof window !== 'undefined' && window.location.pathname.includes('en-US');

/** odds 返回的4种类型 */
export const oddsTypes = ['WIN', 'PLA', 'QIN', 'QPL', 'TRI'];

/** 新的BetType 类型
 * - `WIN`: Win-1值
 * - `PLA`: Place-1值
 * - `QIN`: Quinella-马匹组合值
 * - `QPL`: Quinella Place-马匹组合值
 * - `QQP`: QIN & QPL 的马匹组合值
 * - `WP`: WIN & PLA 的马匹组合值
 * - `TRIO`: TRI 1+2+3 方式
 */
export const IsNewBetType = ['WIN', 'PLA', 'QIN', 'QPL', 'QQP', 'WP', 'TRIO'];

/** Win-Place样式不同 */
export const isWinPLA = 'WP';

/** 组合样式不同
 *  - `QIN`: Quinella-马匹组合值
 *  - `QPL`: Quinella Place-马匹组合值
 *  - `QQP`: QIN & QPL 的马匹组合值
 *  - `TRIO`: TRI 的马匹组合值
 */
export const isCOMBI = ['QIN', 'QPL', 'QQP', 'TRIO'];

/**
 * TRIO
 * 1+5+8 格式
 */
export const isTrio = ['TRI'];

/** SCR类型处理
 * - `Scratched`
 */
export const SCRStatus = ['Scratched'];
/** (R)类型处理
 * - `Standby`
 * - `SratchedReserved`
 */
export const RStatus = ['Standby', 'SratchedReserved'];
/** 同时SCR和(R)类型处理
 *  - `ScratchedReserved`
 */
export const SCRRStatus = ['ScratchedReserved'];

/** 从RacingData中过滤传入的场次及马匹 */
export const getFilteredRunners = (racesList: any, raceNo: number, runnerNos: string[]) => {
    // 找到对应的场次
    const race = racesList.find((r: any) => r.no === raceNo);

    if (!race) {
        return []; // 如果没有找到该场次，返回空数组
    }

    // 过滤出对应的跑马
    const filteredRunners = race.runners.filter((runner: any) => runnerNos.includes(runner.no));

    return filteredRunners;
};

/** 通过投注类型编号及马匹编号获取
 * - 马匹中英名字 |
 * - 马匹赔率 |
 * - 马匹hot |
 */

/** 组合CMS 查询条件
 *  
if （bankerRow有值） {
    bankerRow+selRow
    bankerRow+selRow2nd
    bankerRow+selRow3rd
    bankerRow+selRow4th
} else {
    if 只有有selRow值就输出selRow
    if selRow和selRow2nd有值就输出 selRow+selRow2nd
    if selRow和selRow2nd和selRow3rd有值就输出
    selRow+selRow2nd
    selRow+selRow3rd
    selRow2nd+selRow3rd
    if selRow和selRow2nd和selRow3rd和selRow4th有值就输出
    selRow+selRow2nd
    selRow+selRow3rd
    selRow+selRow4th
    selRow2nd+selRow3rd
    selRow2nd+selRow4th
    selRow3rd+selRow4th
}
转成['08,09', '08,11', '08,10', '09,11', '09,10', '10,11']
if(betPickType?.targetItem?.name === 'TRIO') {
    if （bankerRow有值） {
    bankerRow+selRow+selRow2nd
    bankerRow+selRow+selRow3rd
    bankerRow+selRow+selRow4th
    bankerRow+selRow2nd+selRow3rd
    bankerRow+selRow2nd+selRow4th
    bankerRow+selRow3rd+selRow4th
    } else {
    if selRow和selRow2nd和selRow3rd有值就输出
    selRow+selRow2nd+selRow3rd
    if selRow和selRow2nd和selRow3rd和selRow4th有值就输出
    selRow+selRow2nd+selRow3rd
    selRow+selRow2nd+selRow4th
    selRow+selRow3rd+selRow4th
    selRow2nd+selRow3rd+selRow4th
    }
}
转成['08,09,11', '08,09,12']
 */
// 旧处理
// export const BetDataProcessor = (CMSBetpick: DeepReadonly<BetPickEntryFragment>) => {
//     const { bankerRow, selRow, selRow2nd, selRow3rd, selRow4th } = CMSBetpick;
//     // console.log('data============', CMSBetpick);

//     if (bankerRow?.value) {
//         const values = [bankerRow, selRow, selRow2nd, selRow3rd, selRow4th];
//         // console.log('values=======', values);

//         // 生成组合
//         const result: string[] = values
//             .map((item: any) => item.value) // 提取值
//             .filter(Boolean) // 过滤掉空值
//             .filter((value) => value !== bankerRow.value) // 过滤掉 bankerRow 自身
//             .reduce((acc: Set<string>, value: string) => {
//                 const paddedValue = padWithZero(value);
//                 const paddedBankerValue = padWithZero(bankerRow.value ?? '');

//                 // 判断 bankerRow 的值与选择值的大小
//                 if (parseInt(bankerRow.value ?? '') > parseInt(value)) {
//                     acc.add(`${paddedValue},${paddedBankerValue}`); // 小的在前
//                 } else {
//                     acc.add(`${paddedBankerValue},${paddedValue}`); // bankerRow 在前
//                 }

//                 return acc;
//             }, new Set());

//         return [...new Set(result)];
//     } else {
//         const getResult = (...rows: any) => {
//             const validValues = rows
//                 .map((row: any) => row?.value)
//                 .filter(Boolean)
//                 .map(padWithZero);

//             // 生成组合
//             const result = validValues.flatMap((value: any, index: any) =>
//                 validValues
//                     .slice(index + 1)
//                     .map((nextValue: any) => `${padWithZero(value)},${padWithZero(nextValue)}`)
//             );

//             return [...new Set(result)]; // 去重
//         };

//         const result = getResult(selRow, selRow2nd, selRow3rd, selRow4th);
//         return result;
//     }
// };
export const BetDataProcessor = (CMSBetpick: DeepReadonly<BetPickEntryFragment>) => {
    const { bankerRow, selRow, selRow2nd, selRow3rd, selRow4th, betPickType } = CMSBetpick;
    const rows = [selRow, selRow2nd, selRow3rd, selRow4th];

    const pad = (val: string) => val.toString().padStart(2, '0');

    const getValidValues = (items: any[]): string[] =>
        items
            .map((item) => item?.value)
            .filter(Boolean)
            .map(pad);

    const generateCombinations = (values: string[], size: number): string[] => {
        const result: string[] = [];

        const backtrack = (start: number, path: string[]) => {
            if (path.length === size) {
                result.push(path.slice().sort().join(','));
                return;
            }
            for (let i = start; i < values.length; i++) {
                path.push(values[i]);
                backtrack(i + 1, path);
                path.pop();
            }
        };

        backtrack(0, []);
        return [...new Set(result)];
    };

    const isTrio = betPickType?.targetItem?.name === 'TRIO';

    if (bankerRow?.value) {
        const banker = pad(bankerRow.value);
        const others = getValidValues(rows).filter((val) => val !== banker);

        const result = new Set<string>();
        if (isTrio) {
            // 生成 banker + 任意两个 others 的组合
            for (let i = 0; i < others.length; i++) {
                for (let j = i + 1; j < others.length; j++) {
                    const trio = [banker, others[i], others[j]].sort().join(',');
                    result.add(trio);
                }
            }
        } else {
            // 生成 banker + 单个 other 的组合
            others.forEach((val) => {
                const pair =
                    parseInt(bankerRow?.value || '') > parseInt(val)
                        ? `${val},${banker}`
                        : `${banker},${val}`;
                result.add(pair);
            });
        }

        return [...result];
    }
    const validValues = getValidValues(rows);
    const combinationSize = isTrio ? 3 : 2;
    return generateCombinations(validValues, combinationSize);
};
/** 字符串个位数转换
 * 2 => 02
 */
export const padWithZero = (str: string) => (str.length === 1 ? `0${str}` : str);

/** 字符串个位数转换
 * 02 => 2
 */
export const removeLeadingZero = (str: string) => (str.startsWith('0') ? str.slice(1) : str);

/** 数据处理 */
export const CMSData = (
    betpick: DeepReadonly<BetPickEntryFragment>,
    raceRunner: any[],
    oddsList: any[],
    lang: boolean,
    t: any
) => {
    // console.log('betpick-----', betpick);
    // console.log('raceRunner-----', raceRunner);
    // console.log('oddsList-----', oddsList);
    const {
        betPickType,
        bankerRow,
        selRow,
        selRow2nd,
        selRow3rd,
        selRow4th,
        bankerRowIcon,
        bankerRowTips,
        selRowIcon,
        selRowTips,
        selRow2ndIcon,
        selRow2ndTips,
        selRow3rdIcon,
        selRow3rdTips,
        selRow4thIcon,
        selRow4thTips,
    } = betpick;

    /** 白板数据封装 */
    const getWhiteV = (data: string, i: any, isSCR: boolean) => {
        // const isSCR = SCRStatus.includes(i.status);
        const isR = RStatus.includes(i.status);
        const isSCRR = SCRRStatus.includes(i.status);
        const name = `${i.no}. ${isR || isSCRR ? t('betpick.r') : ''}${
            lang ? i.name_en : i.name_ch
        }${isSCR || isSCRR ? ` (${t('betpick.scratched')})` : ''}`;

        if (data === bankerRow?.value) {
            return {
                whiteName: name,
                whiteText: bankerRowTips?.rendered,
                whiteIcon: bankerRowIcon?.src,
            };
        } else if (data === selRow?.value) {
            return {
                whiteName: name,
                whiteText: selRowTips?.rendered,
                whiteIcon: selRowIcon?.src,
            };
        } else if (data === selRow2nd?.value) {
            return {
                whiteName: name,
                whiteText: selRow2ndTips?.rendered,
                whiteIcon: selRow2ndIcon?.src,
            };
        } else if (data === selRow3rd?.value) {
            return {
                whiteName: name,
                whiteText: selRow3rdTips?.rendered,
                whiteIcon: selRow3rdIcon?.src,
            };
        } else if (data === selRow4th?.value) {
            return {
                whiteName: name,
                whiteText: selRow4thTips?.rendered,
                whiteIcon: selRow4thIcon?.src,
            };
        }
    };
    const betPickTypeName = betPickType?.targetItem?.name ?? '';

    const dataList = [
        bankerRow?.value,
        selRow?.value,
        selRow2nd?.value,
        selRow3rd?.value,
        selRow4th?.value,
    ].filter(Boolean);

    if (isCOMBI.includes(betPickTypeName)) {
        const proceDataList = BetDataProcessor(betpick); // 组合查询数据

        // 创建结果对象
        const result: any = {
            horseList: [],
            tableList: [],
        };

        // 生成 horseList
        dataList.forEach((data) => {
            const runner = raceRunner.find((r) => r.no === data);
            if (runner) {
                const qinOddsValue = oddsList
                    .find((odds) => odds.oddsType === 'QIN')
                    ?.oddsNodes.find((node: any) => node.combString === data)?.oddsValue;
                const qplOddsValue = oddsList
                    .find((odds) => odds.oddsType === 'QPL')
                    ?.oddsNodes.find((node: any) => node.combString === data)?.oddsValue;

                const qinOddsSCR = qinOddsValue ? qinOddsValue === 'SCR' : false;
                const qplOddsSCR = qplOddsValue ? qplOddsValue === 'SCR' : false;

                const isSCR = SCRStatus.includes(runner.status) || qinOddsSCR || qplOddsSCR;

                result.horseList.push({
                    no: runner.no,
                    isBankerROw: !!bankerRow?.value,
                    status: runner.status,
                    name_ch: runner.name_ch,
                    name_en: runner.name_en,
                    ...getWhiteV(data || '', runner, isSCR),
                });
            }
        });

        // 生成 tableList
        if (betPickTypeName === 'QQP') {
            const findOddsByType = (type: string) =>
                oddsList?.find((odds) => odds?.oddsType === type);
            const findOddsNode = (type: string, combString: any) =>
                findOddsByType(type)?.oddsNodes?.find(
                    (node: any) => node?.combString === combString
                );

            const QINOddsLastDate = findOddsByType('QIN')?.lastUpdateTime || '';
            const QPLOddsLastDate = findOddsByType('QPL')?.lastUpdateTime || '';
            OddsStore.addLastUpdateDate([...new Set([QINOddsLastDate, QPLOddsLastDate])]);

            const formatHorseName = (horse: any) => {
                const { no, status } = horse;
                const scr = SCRStatus.includes(status);
                const r = RStatus.includes(status);
                const scrr = SCRRStatus.includes(status);

                if (scrr) return `${isEn ? '(R)' : '(備)'}${no} ${isEn ? '(SCR)' : '(退出)'}`;
                if (scr) return `${no} ${isEn ? '(SCR)' : '(退出)'}`;
                if (r) return `${isEn ? '(R)' : '(備)'}${no}`;
                return no;
            };

            const getHorseStatusList = (matchNosArray: any) =>
                matchNosArray
                    .map((no: string) => {
                        const horse = result.horseList.find((item: any) => item.no === no);
                        return horse ? { ...horse, name: formatHorseName(horse) } : null;
                    })
                    .filter(Boolean);

            const generateCombinations = (horses: any) => {
                const seen = new Set();
                const combos: any[] = [];

                horses.forEach((horse1: any, i: number) => {
                    horses.slice(i + 1).forEach((horse2: any) => {
                        const comb = `${horse1.name} + ${horse2.name}`;
                        if (!seen.has(comb)) {
                            seen.add(comb);
                            combos.push(comb);
                        }
                    });
                });

                return combos;
            };

            const getOddsValue = (odds: any, isSCR: boolean) =>
                isSCR ? (isEn ? 'SCR' : '退出') : odds?.oddsValue || '---';

            const getDropValue = (odds: any) => odds?.oddsDropValue || 0;

            const hasQIN = !!findOddsByType('QIN');
            const hasQPL = !!findOddsByType('QPL');

            if (hasQIN || hasQPL) {
                proceDataList.forEach((combString) => {
                    const matchNosArray = combString.split(',').map((no) => no.replace(/^0/, ''));
                    const horses = getHorseStatusList(matchNosArray);

                    const isSCR = matchNosArray.some((no) =>
                        result.horseList.some(
                            (item: any) => item.no === no && SCRStatus.includes(item.status)
                        )
                    );
                    const isSCRR = matchNosArray.some((no) =>
                        result.horseList.some(
                            (item: any) => item.no === no && SCRRStatus.includes(item.status)
                        )
                    );

                    const qinOdds = findOddsNode('QIN', combString);
                    const qplOdds = findOddsNode('QPL', combString);

                    const combinations = generateCombinations(horses);

                    // console.log('combinations=====', combinations);

                    combinations.forEach((comb) => {
                        result.tableList.push({
                            combString: comb,
                            horsename: comb,
                            QINHotFavourite: qinOdds?.hotFavourite || false,
                            QINOddsValue: getOddsValue(qinOdds, isSCR || isSCRR),
                            QINOddsDropValue: getDropValue(qinOdds),
                            QPLHotFavourite: qplOdds?.hotFavourite || false,
                            QPLOddsValue: getOddsValue(qplOdds, isSCR || isSCRR),
                            QPLOddsDropValue: getDropValue(qplOdds),
                        });
                    });
                });
            }
        } else if (['QIN', 'QPL'].includes(betPickTypeName)) {
            const findBetpick = oddsList.find((odds) => odds.oddsType === betPickTypeName);

            const winOddsLastDate =
                findBetpick?.lastUpdateTime !== 'null' ? findBetpick?.lastUpdateTime : '';
            OddsStore.addLastUpdateDate(winOddsLastDate);

            const formatHorseName = ({ no, isSCR, isR, isSCRR }: any) => {
                if (isSCRR) return `${isEn ? '(R)' : '(備)'}${no} ${isEn ? '(SCR)' : '(退出)'}`;
                if (isSCR) return `${no} ${isEn ? '(SCR)' : '(退出)'}`;
                if (isR) return `${isEn ? '(R)' : '(備)'}${no}`;
                return no;
            };

            if (findBetpick) {
                proceDataList.forEach((combString) => {
                    const matchNosArray = combString.split(',').map((no) => no.replace(/^0/, ''));
                    const odds = findBetpick?.oddsNodes?.find(
                        (node: any) => node.combString === combString
                    );

                    const horsesWithStatus = matchNosArray
                        .map((no) => {
                            const horse = result.horseList.find((item: any) => item.no === no);
                            return horse
                                ? {
                                      no,
                                      isSCR: SCRStatus.includes(horse.status),
                                      isR: RStatus.includes(horse.status),
                                      isSCRR: SCRRStatus.includes(horse.status),
                                  }
                                : null;
                        })
                        .filter(Boolean);

                    const isSCR = horsesWithStatus.some((h: any) => h.isSCR);
                    const isSCRR = horsesWithStatus.some((h: any) => h.isSCRR);

                    const seenCombos = new Set();

                    horsesWithStatus.forEach((horse1: any, i) => {
                        horsesWithStatus.slice(i + 1).forEach((horse2: any) => {
                            const comb = `${formatHorseName(horse1)} + ${formatHorseName(horse2)}`;
                            if (!seenCombos.has(comb)) {
                                seenCombos.add(comb);
                                result.tableList.push({
                                    combString: comb,
                                    horsename: comb,
                                    [`${betPickTypeName}HotFavourite`]: odds?.hotFavourite || false,
                                    [`${betPickTypeName}OddsValue`]:
                                        isSCR || isSCRR
                                            ? isEn
                                                ? 'SCR'
                                                : '退出'
                                            : odds?.oddsValue || '---',
                                    [`${betPickTypeName}OddsDropValue`]:
                                        odds?.oddsDropValue ?? null,
                                });
                            }
                        });
                    });
                });
            }
        } else if (betPickTypeName === 'TRIO') {
            // console.log('TRIO----', proceDataList);
            const findBetpick = oddsList.find((odds) => odds.oddsType === 'TRI');
            const TRIOOddsLastDate =
                findBetpick?.lastUpdateTime !== 'null' ? findBetpick?.lastUpdateTime : '';
            OddsStore.addLastUpdateDate(TRIOOddsLastDate);
            // console.log('TRIOfindBetpick----', findBetpick);

            const formatHorseName = ({ no, isSCR, isR, isSCRR }: any) => {
                if (isSCRR) return `${isEn ? '(R)' : '(備)'}${no} ${isEn ? '(SCR)' : '(退出)'}`;
                if (isSCR) return `${no} ${isEn ? '(SCR)' : '(退出)'}`;
                if (isR) return `${isEn ? '(R)' : '(備)'}${no}`;
                return no;
            };

            if (findBetpick) {
                const seenCombos = new Set();
                proceDataList.forEach((combString) => {
                    const matchNosArray = combString.split(',').map((no) => no.replace(/^0/, ''));
                    const odds = findBetpick?.oddsNodes?.find(
                        (node: any) => node.combString === combString
                    );

                    const horsesWithStatus = matchNosArray
                        .map((no) => {
                            const horse = result.horseList.find((item: any) => item.no === no);
                            return horse
                                ? {
                                      no,
                                      isSCR: SCRStatus.includes(horse.status),
                                      isR: RStatus.includes(horse.status),
                                      isSCRR: SCRRStatus.includes(horse.status),
                                  }
                                : null;
                        })
                        .filter(Boolean);

                    const isSCR = horsesWithStatus.some((h: any) => h.isSCR);
                    const isSCRR = horsesWithStatus.some((h: any) => h.isSCRR);

                    // 三匹马组合逻辑
                    horsesWithStatus.forEach((horse1, i) => {
                        horsesWithStatus.slice(i + 1).forEach((horse2, j) => {
                            horsesWithStatus.slice(i + j + 2).forEach((horse3) => {
                                const comb = `${formatHorseName(horse1)} + ${formatHorseName(
                                    horse2
                                )} + ${formatHorseName(horse3)}`;
                                if (!seenCombos.has(comb)) {
                                    seenCombos.add(comb);
                                    result.tableList.push({
                                        combString: comb,
                                        horsename: comb,
                                        TRIOHotFavourite: odds?.hotFavourite || false,
                                        TRIOOddsValue:
                                            isSCR || isSCRR
                                                ? isEn
                                                    ? 'SCR'
                                                    : '退出'
                                                : odds?.oddsValue || '---',
                                        TRIOOddsDropValue: odds?.oddsDropValue ?? null,
                                    });
                                }
                            });
                        });
                    });
                });
            } else {
                result.tableList = [];
            }
        }
        return result;
    } else if (betPickTypeName === isWinPLA) {
        const result = dataList
            .map((dataNo) => {
                // 找到对应的 raceRunner
                const runner = raceRunner.find((r) => r.no === dataNo);
                if (runner) {
                    const winOddsListObj = oddsList.find((i) => i.oddsType === 'WIN');
                    const PLAOddsListObj = oddsList.find((i) => i.oddsType === 'PLA');

                    // last update 处理
                    const winOddsLastDate =
                        winOddsListObj?.lastUpdateTime && winOddsListObj?.lastUpdateTime !== 'null'
                            ? winOddsListObj?.lastUpdateTime
                            : '';
                    const PLAOddsLastDate =
                        PLAOddsListObj?.lastUpdateTime && PLAOddsListObj?.lastUpdateTime !== 'null'
                            ? PLAOddsListObj?.lastUpdateTime
                            : '';
                    const lastDateList = Array.from(new Set([winOddsLastDate, PLAOddsLastDate]));

                    OddsStore.addLastUpdateDate(lastDateList);

                    // 找到对应的 oddsNode
                    const winOddsNode = winOddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });
                    const PLAOddsNode = PLAOddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });

                    const winOddsSCR = winOddsNode ? winOddsNode?.oddsValue === 'SCR' : false;
                    const PLAOddsSCR = PLAOddsNode ? PLAOddsNode?.oddsValue === 'SCR' : false;

                    const isSCR = SCRStatus.includes(runner.status) || winOddsSCR || PLAOddsSCR;

                    return {
                        no: runner.no,
                        status: runner.status,
                        name_ch: runner.name_ch,
                        name_en: runner.name_en,
                        winOddsValue: winOddsNode ? winOddsNode.oddsValue : '---',
                        winHotFavourite: winOddsNode ? winOddsNode.hotFavourite : null,
                        winOddsDropValue: winOddsNode ? winOddsNode.oddsDropValue : 0,
                        PLAOddsValue: PLAOddsNode ? PLAOddsNode.oddsValue : '---',
                        PLAHotFavourite: PLAOddsNode ? PLAOddsNode.hotFavourite : null,
                        PLAOddsDropValue: PLAOddsNode ? PLAOddsNode.oddsDropValue : 0,
                        ...getWhiteV(dataNo || '', runner, isSCR),
                    };
                }
                return null; // 如果没有找到对应的 raceRunner，返回 null
            })
            .filter((item) => item !== null);
        return result;
    } else if (betPickTypeName === 'PLA') {
        const result = dataList
            .map((dataNo) => {
                // 找到对应的 raceRunner
                const runner = raceRunner.find((r) => r.no === dataNo);
                if (runner) {
                    const oddsListObj = oddsList.find((i) => i.oddsType === 'PLA');
                    // last update 处理
                    const oddsLastDate =
                        oddsListObj?.lastUpdateTime && oddsListObj?.lastUpdateTime !== 'null'
                            ? oddsListObj?.lastUpdateTime
                            : '';
                    OddsStore.addLastUpdateDate(oddsLastDate);

                    // 找到对应的 oddsNode
                    const oddsNode = oddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });

                    const oddsSCR = oddsNode ? oddsNode?.oddsValue === 'SCR' : false;

                    const isSCR = SCRStatus.includes(runner.status) || oddsSCR;

                    return {
                        no: runner.no,
                        status: runner.status,
                        name_ch: runner.name_ch,
                        name_en: runner.name_en,
                        oddsValue: oddsNode ? oddsNode.oddsValue : '---',
                        hotFavourite: oddsNode ? oddsNode.hotFavourite : null,
                        oddsDropValue: oddsNode ? oddsNode.oddsDropValue : 0,
                        ...getWhiteV(dataNo || '', runner, isSCR),
                    };
                }
                return null;
            })
            .filter((item) => item !== null);
        return result;
    } else {
        const result = dataList
            .map((dataNo) => {
                // 找到对应的 raceRunner
                const runner = raceRunner.find((r) => r.no === dataNo);
                if (runner) {
                    const oddsListObj = oddsList.find((i) => i.oddsType === 'WIN');
                    // last update 处理
                    const oddsLastDate =
                        oddsListObj?.lastUpdateTime && oddsListObj?.lastUpdateTime !== 'null'
                            ? oddsListObj?.lastUpdateTime
                            : '';
                    OddsStore.addLastUpdateDate(oddsLastDate);

                    // 找到对应的 oddsNode
                    const oddsNode = oddsListObj?.oddsNodes?.find((odds: any) => {
                        const newDataNo = padWithZero(dataNo ?? '');
                        if (odds.combString === newDataNo) {
                            return odds;
                        }
                    });

                    const oddsSCR = oddsNode ? oddsNode?.oddsValue === 'SCR' : false;

                    const isSCR = SCRStatus.includes(runner.status) || oddsSCR;

                    return {
                        no: runner.no,
                        status: runner.status,
                        name_ch: runner.name_ch,
                        name_en: runner.name_en,
                        oddsValue: oddsNode ? oddsNode?.oddsValue : '---',
                        hotFavourite: oddsNode ? oddsNode?.hotFavourite : null,
                        oddsDropValue: oddsNode ? oddsNode?.oddsDropValue : 0,
                        ...getWhiteV(dataNo || '', runner, isSCR),
                    };
                }
                return null;
            })
            .filter((item) => item !== null);
        return result;
    }
};

/**
 * if hotFavorite == true  Favorite
 * else oddsDropValue >= 50  Odds Drop by 50%
 * else oddsDropValue >= 20  Odds Drop by 20%
 */
export const oddsDropBlock = (hotFavorite: boolean, oddsDropValue: number) => {
    if (hotFavorite) {
        return 'bg-[#FF0000] rounded text-white';
    } else if (oddsDropValue >= 50) {
        return 'bg-[#B64D18] rounded text-white';
    } else if (oddsDropValue >= 20) {
        return 'bg-[#6EBC3F] rounded text-white';
    }
};

/** 过滤all up item */
export const filterByKolName = (
    data: AllupBetlineFragment[],
    name: string
): AllupBetlineFragment[] => {
    return data
        .filter((item): item is AllupBetlineFragment => !!item)
        .filter(
            (item) =>
                item.kolProfile?.targetItem?.name?.toLowerCase() === name.toLowerCase() &&
                item.allUpEnabled?.boolValue
        );
};

/** 获取path内的betline和race数据 */
export const getRaceNum = (path: string) => {
    const match = path.match(/betpick\/([^/]+)\/([^/]+)/);
    if (match) {
        return {
            betline: match[1], // 比如 20230919S5_DO
            race: match[2], // 比如 R1（动态值）
        };
    }
    return null;
};
